export default "__VITE_ASSET__be5693bf__"